module.exports = __webpack_public_path__ + "img/logohauseful.1bbec31d.png";